import { useEffect, useState } from "react"
import { Card } from "../components/Card"
import { AccountList } from "../account/AccountList"
import Grid from "@mui/material/Grid"
import Item from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import MessageIcon from '@mui/icons-material/Message';
import ReceiptIcon from '@mui/icons-material/Receipt';
import Stack from "@mui/material/Stack"
import { Account } from "@sb1finans/new-api"
import { useHistory, useLocation } from "react-router-dom"
import { useAccounts, useInvoices, useObjects, useUpcomingInvoices } from "../state/AppDataStateProvider"
import { formatDate } from "../utils/formatters"
import { AccountWithObject } from "../providers/AccountProvider"

export const HomePage = () => {
    
    const accounts = useAccounts()
    const accountObjects = useObjects()
    const history = useHistory()
    const location = useLocation()

    const invoices = useUpcomingInvoices()

    const onSelectAccount = (account: Account) => {
        console.log("From Home page:", account)
        history.push(`${location.pathname}/kontoer/${account.id}`)
    }

    const onSelectInvoice = (accountId: string) => () => {
        history.push(`${location.pathname}/kontoer/${accountId}/fakturaer`)
    }

    const isDateBeforeDate = (date: Date, otherDate: Date) => {
        return date.setHours(0, 0, 0, 0) < otherDate.setHours(0, 0, 0, 0)
    }

    const accountsWithObjects = accounts.map(account => {
        const objects = accountObjects.get(account.id)
        return {
            account,
            objects
        } as AccountWithObject
    })

    console.log("AccountsWithObjects:", accountsWithObjects)

    return (
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Item>
                <AccountList onSelectAccount={onSelectAccount} accounts={accountsWithObjects} />
            </Item>
          </Grid>
          {/*<Grid item xs={12} md={4}>
            <Stack spacing={2}>
                <Typography variant="h5" sx={{color: "#002776"}}>Nye brev</Typography>
                <Card icon={<MessageIcon />} title="Meldinger" />
            </Stack>
    </Grid>*/}
          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
                { Array.from(invoices).some(([accountId, invoice]) => invoice != undefined) && <Typography variant="h5" sx={{color: "#002776"}}>Fakturaer</Typography> }
                {
                    Array.from(invoices).map(([accountId, invoice]) => {
                        const firstInvoice = invoice
                        if (!firstInvoice) return
                        console.log("First invoice:", firstInvoice)
                        const invoiceDate = new Date(firstInvoice.invoiceDate)
                        const formattedInvoiceDate = `${(invoiceDate.getMonth() + 1).toString().padStart(2, '0')}.${invoiceDate.getFullYear()}`

                        const dueDate = new Date(firstInvoice.dueDate)
                        return (
                            <Card
                                key={firstInvoice.invoiceId}
                                onClick={onSelectInvoice(accountId)}
                                icon={<ReceiptIcon sx={{width: "40px", height: "40px"}}/>}
                                title={`Faktura ${formattedInvoiceDate}`}
                                subtitle={<Typography variant="body2" color={isDateBeforeDate(dueDate, new Date()) ? "#ff0000" : "darkgray"}>{`Forfall: ${formatDate(new Date(dueDate))}`}</Typography>}
                            />
                    )})
                }
            </Stack>
          </Grid>
        </Grid>
    )
}

//42010700064
